import {
  Card,
  CardHeader,
  CardContent,
  Avatar,
  Typography,
  Box,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AssessmentIcon from "@mui/icons-material/Assessment";
import MarkdownRenderer from "./MarkdownRenderer";
import PropTypes from "prop-types";

const AIAnswerCard = ({ aiAnswer, t }) => {
  const theme = useTheme();

  if (!aiAnswer) return null;

  return (
    <Card
      sx={{
        mb: 3,
        borderLeft: "6px solid",
        borderColor: "info.main",
        boxShadow: theme.shadows[4],
      }}
    >
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: "info.main" }}>
            <AssessmentIcon />
          </Avatar>
        }
        title={
          <Typography variant="h6" fontWeight="bold">
            {t("documentDetail.aiReviewTitle")}
          </Typography>
        }
        subheader={
          <Box>
            <Typography variant="body2" color="warning.main" fontWeight="bold">
              {t("documentDetail.aiWarning")}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {t("documentDetail.aiDisclaimer")}
            </Typography>
          </Box>
        }
      />
      <CardContent>
        <MarkdownRenderer content={aiAnswer} />
      </CardContent>
    </Card>
  );
};

AIAnswerCard.propTypes = {
  aiAnswer: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default AIAnswerCard;
